"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _multiSelectFilter = _interopRequireDefault(require("./base/multi-select-filter.store"));
var _airlineFilter = require("../../utils/filters/airline-filter.utils");
var _filters = require("../../constants/filters.constants");
var _dec, _dec2, _class;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AirlineFilter = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, (_class = function (_MultiSelectFilter) {
  (0, _inherits2.default)(AirlineFilter, _MultiSelectFilter);
  function AirlineFilter(filterData, $env, flightInfo) {
    var _this;
    (0, _classCallCheck2.default)(this, AirlineFilter);
    _this = _callSuper(this, AirlineFilter, [$env]);
    _this.flightInfo = void 0;
    _this.id = _filters.FILTER_MAP.AIRLINE;
    _this.flightInfo = flightInfo;
    _this.initialize(filterData);
    (0, _mobx.autorun)(function () {
      if (_this.flightInfo.resources.isFetched) {
        _this.initialize(_this.data, _this.cachedSelected.join(","));
      }
    });
    return _this;
  }
  (0, _createClass2.default)(AirlineFilter, [{
    key: "initialize",
    value: function initialize(data, query, withCommit) {
      if (query === void 0) {
        query = "";
      }
      if (withCommit === void 0) {
        withCommit = true;
      }
      this.data = data;
      this.uncommittedState = (0, _airlineFilter.initializeState)(data, this.flightInfo.$resources.getAirlineLabel);
      if (withCommit) {
        this.state = this.uncommittedState;
      }
      if (query) {
        this.update(query, withCommit);
      }
    }
  }, {
    key: "clone",
    value: function clone(filterState) {
      this.cachedSelected = filterState.filter(function (_ref) {
        var selected = _ref.selected;
        return selected;
      }).map(function (_ref2) {
        var code = _ref2.code;
        return code;
      });
      this.uncommittedState = filterState;
      this.commit();
    }
  }]);
  return AirlineFilter;
}(_multiSelectFilter.default), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "initialize", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "clone", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "clone"), _class.prototype)), _class));